export default __webpack_public_path__ + "/assets/map-pin-orange-filled.41e86a7fe1135237eef60c4ecc74ecd1.png";